import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-693fc703"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center flex-nowrap w-full" }
const _hoisted_2 = { class: "truncate" }
const _hoisted_3 = { style: {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                } }
const _hoisted_4 = { class: "m-[4px]" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "uil uil-copy text-[24px] text-Text/text_low"
}
const _hoisted_7 = {
  key: 0,
  class: "workloads-table-floating-row-container"
}
const _hoisted_8 = { class: "absolute mt-[39px] left-0 bg-System/app_warning_bg rounded-b-sm gap-2 flex flex-row px-3 py-0.5 items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uis uis-exclamation-triangle text-Text/text_warning text-[16px]" }, null, -1))
const _hoisted_10 = { class: "gordita-400-11" }
const _hoisted_11 = {
  key: 0,
  class: "absolute top-0 left-0 right-0 bottom-0"
}
const _hoisted_12 = {
  key: 1,
  class: "absolute top-0 left-0 right-0 bottom-0"
}
const _hoisted_13 = { class: "flex-grow flex w-full h-[calc(100%-40px)] bg-System/app_white justify-center" }
const _hoisted_14 = { class: "font-gordita-regular text-[14px] text-Text/text_medium flex flex-center" }
const _hoisted_15 = { class: "font-gordita-regular pl-[12px] pr-[19px] flex items-center justify-between bg-System/app_white outline outline-1 outline-System/app_border whitespace-nowrap rounded-b-[2px]" }
const _hoisted_16 = { class: "text-[11px] leading-[15px] mr-[16px] text-Text/text_medium flex items-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-Text/text_high" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ellipsis-seperator mx-3 w-1 h-1 rounded-[50%] bg-[#374A5080]" }, null, -1))
const _hoisted_24 = { class: "text-Text/text_high" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " in filter", -1))
const _hoisted_26 = { class: "flex gap-8 justify-between z-10" }
const _hoisted_27 = { class: "flex items-center gap-[23px] h-[40px] ml-auto" }
const _hoisted_28 = { class: "flex items-center gap-[8px] ml-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-gordita-regular text-[11px] text-Text/text_medium" }, "Show: ", -1))

import { computed, inject, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { IncrediPagination, IncrediSelect, IncrediTable, IncrediTooltip } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import EmptyBuildsSearch from '@/views/workloads/components/tableComponents/emptyWorkloads.vue';
import { copyToClipboard } from '@/services/utils';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useNotify } from '@/services/notify/notify';
import { Builds_SortOrder } from '@/graphql/codegen/generated/graphql';
import WorkloadStatus from '@/views/workloads/components/tableComponents/workloadStatus.vue';
import { dateUtils } from '@/services/dateUtils';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { useWorkloadsTableUtils } from '@/views/workloads/workloads.utils';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { NetworkStatus } from '@apollo/client/core';
import { useMatomo } from '@/services/matomo/matomo.service';
import { useOsService } from '@/services/OsService/OsService';
import { useWorkloadsColumnsManagement } from '@/views/workloads/components/navbarComponents/manageColumns/manage-columns.helpers';
import { WorkloadsTableColumns } from '@/views/workloads/workloads-table.types';
import { Routes } from '@/router/router.const';
import TableCell from './tableComponents/workloadsTableCell.vue';
import { LOG_LEVEL_WORKLOADS, useWorkloadsTableConstants } from '../workloads.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'workloadsTable',
  emits: ["onScroll", "clearFilters"],
  setup(__props, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'onScroll', state: { isScrolling: boolean }): void;
  (e: 'clearFilters'): void;
}), expose: any, slots: any, attrs: any }) {

const isScrolling = ref(false);
const hoveredRow = ref<number | undefined>(undefined);
const matomo = useMatomo();
const { toastMessage } = useNotify();
const { t } = useI18n();
const workloadsPageData = inject(IKWorkloadsPageData);
const { secondsToHoursMinutesAndSeconds, handlePageResize, handleDynamicColumns } = useWorkloadsTableUtils();
const platformAuthentication = inject(IKPlatformAuthentication);
const osService = useOsService();
const workloadsConstants = useWorkloadsTableConstants();
const workloadsManagement = useWorkloadsColumnsManagement();
const router = useRouter();
const isUnmetHelperRequestsHeaderHovered = ref(false);

const editTable = workloadsManagement?.tableEditor;
const possibleFailReasons = workloadsConstants.WORKLOADS_FAIL_REASON;

const isManageColumnsFilterEmpty = computed(() => Object.values(editTable?.get[osService.osType.value].value.columnsFilter).every(value => !value));
const isWindows = computed(() => osService?.isWindows.value);
const columns = computed(() => workloadsManagement?.tableColumns[osService.osType.value || OsType.Windows].value || []);
const workloads = computed(() => workloadsPageData?.workloads.value?.builds || []);
const totalWorkloadsCount = computed(() => workloadsPageData?.workloads.value?.totalCount || 0);
const totalFilteredWorkloadsCount = computed(() => workloadsPageData?.workloads.value?.totalFilteredCount || 0);
const areFiltersApplied = computed(() => !!workloadsPageData?.filter?.get?.value?.searchFilter || !workloadsPageData?.filter?.areFiltersInDefaultState.value);

const sortMapByOS = workloadsConstants.WORKLOADS_SORT_TO_COLUMNS_MAP[platformAuthentication?.osType?.value || OsType.Windows];

const filteredColumns = computed(() => handleDynamicColumns(columns.value).filter(column => editTable?.get[osService.osType.value].value.columnsFilter[column.name]));

const sortModel = ref({});

const sortModelValue = computed({
  get() {
    return {
      sort: {
        name: sortMapByOS[workloadsPageData?.filter?.get?.value?.sort?.field as keyof typeof sortMapByOS],
        descending: workloadsPageData?.filter?.get?.value?.sort?.order ? workloadsPageData?.filter?.get?.value?.sort?.order === Builds_SortOrder.Descending : false,
      },
    };
  },
  set(value) {
    sortModel.value = value;
  },
});


const clearFilters = () => {
  workloadsPageData?.filter?.clear();
};

const handleHoverRow = (index: number | undefined) => {
  hoveredRow.value = index;
};

const setIsScrolling = (value: boolean) => {
  if (isScrolling.value !== value) {
    isScrolling.value = value;
    emit('onScroll', { isScrolling: value });
  }
};

const copyCommandToClipboard = (textToCopy: string) => {
  if (textToCopy) {
    copyToClipboard(textToCopy);
    toastMessage(t('generic.copiedToClipboard'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  }
};

const showWorkloadsTotalInFiltersCount = computed(
  () => totalWorkloadsCount.value - totalFilteredWorkloadsCount.value || !workloadsPageData?.filter?.areFiltersInDefaultState.value || workloadsPageData?.filter?.get?.value?.searchFilter,
);

const isValidValue = (value: any) => value !== undefined && value !== null;

const handleSortChange = (tableState: any) => {
  sortModelValue.value = tableState;
  const { name, descending } = tableState.sort;
  const mapping = workloadsConstants.WORKLOADS_COLUMNS_TO_SORT_MAP[platformAuthentication?.osType.value || OsType.Windows];
  workloadsPageData?.filter?.setSorting({ field: mapping[name as keyof typeof mapping], order: descending ? Builds_SortOrder.Descending : Builds_SortOrder.Ascending });
  matomo?.trackEvent({
    category: 'Workloads Sort',
    action: 'Click',
    name: name || '',
  });
};

const openBuild = (id: string) => {
  matomo?.trackEvent({
    category: 'Build list - open build',
    action: 'Click',
    name: `${id}`,
  });
  router.push({ name: Routes.BuildSummary, params: { id } });
};

const onRowClick = (_index: number, row: unknown) => {
  if (!row || !osService?.isWindows.value) {
    return;
  }
  const build = row as { hasExtendedData: boolean; buildId: string } | undefined;

  if (!build?.hasExtendedData) {
    return;
  }
  openBuild(build.buildId);
};

const updateColumnWidth = (column: { columnName: string; width: number }) => {
  const columnNewData = editTable?.get[osService.osType.value].value.columnsOrder?.map((orderedColumn: any) => {
    if (orderedColumn.name === column.columnName) {
      return { ...orderedColumn, width: column.width };
    }
    return orderedColumn;
  });
  // Set the new column width
  editTable?.set[osService.osType.value]({
    columnsOrder: [...(columnNewData || [])],
    columnsFilter: { ...editTable?.get[osService.osType.value].value.columnsFilter },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "flex-grow flex flex-col" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediTable), {
        columns: _unref(filteredColumns),
        "header-tooltip": true,
        "row-height": 40,
        class: "workloads-table flex-grow w-full h-0",
        items: (_unref(workloads) as any) || [],
        "model-value": _unref(sortModelValue),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = 
        (tableState) => {
          handleSortChange(tableState);
        }
      ),
        onOnDrag: _cache[2] || (_cache[2] = state => setIsScrolling(state)),
        onOnScroll: _cache[3] || (_cache[3] = state => setIsScrolling(state.isScrolling?.value)),
        onHoveredRow: handleHoverRow,
        onOnRowClick: onRowClick,
        onOnChangeColumnsWidth: _cache[4] || (_cache[4] = col => updateColumnWidth(col))
      }, _createSlots({
        "header-UnmetHelperRequests": _withCtx(({ column }) => [
          _createVNode(_unref(IncrediTooltip), {
            modelValue: isUnmetHelperRequestsHeaderHovered.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isUnmetHelperRequestsHeaderHovered).value = $event)),
            direction: "top-middle",
            hover: ""
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.workloadsTable.unmetHelperRequestsTooltip.a')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.workloadsTable.unmetHelperRequestsTooltip.b')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.workloadsTable.unmetHelperRequestsTooltip.c')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(column.name), 1)
                ]),
                _createElementVNode("i", {
                  class: _normalizeClass(["ml-[4px] text-[16px] text-Text/text_low", isUnmetHelperRequestsHeaderHovered.value ? 'uis uis-info-circle' : 'uil uil-info-circle'])
                }, null, 2)
              ])
            ]),
            _: 2
          }, 1032, ["modelValue"])
        ]),
        "content-Status": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.startTime)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                status: _unref(workloads)[index]?.buildResult as any,
                value: null,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].buildResult as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, {
                default: _withCtx(() => [
                  (_unref(workloads)[index]?.buildResult)
                    ? (_openBlock(), _createBlock(WorkloadStatus, {
                        key: 0,
                        status: _unref(workloads)[index]?.buildResult as any
                      }, null, 8, ["status"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["status", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-StartTime": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.startTime)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                status: _unref(workloads)[index]?.buildResult as any,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].startTime as WorkloadsTableColumns,
                value: _unref(dateUtils).getFormattedDate(Number(_unref(workloads)[index]?.startTime)) + ' ' + _unref(dateUtils).getFormattedTime(Number(_unref(workloads)[index]?.startTime)),
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["status", "column-name", "value", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-Duration": _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            status: _unref(workloads)[index]?.buildResult as any,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].duration as WorkloadsTableColumns,
            value: _unref(secondsToHoursMinutesAndSeconds)(_unref(workloads)[index]?.duration || 0),
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["status", "column-name", "value", "class"])
        ]),
        "content-InitiatorName": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.initiatorName)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                value: _unref(workloads)[index]?.initiatorName,
                status: _unref(workloads)[index]?.buildResult as any,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].initiatorName as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["value", "status", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-CommandLine": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.commandLine)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                status: _unref(workloads)[index]?.buildResult as any,
                value: undefined,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].commandLine as WorkloadsTableColumns
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "incredi-table-row truncate grid w-full h-full",
                      onClick: _withModifiers(() => copyCommandToClipboard(_unref(workloads)[index]?.commandLine || ''), ["stop","prevent"])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([{ 'generated-command-hover': index === hoveredRow.value }, "command-line-column flex flex-nowrap row items-center w-full justify-between pl-2 pr-[24px] py-[8px] truncate"])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass([index === hoveredRow.value ? 'mr-[8px]' : '', "truncate text-[12px] font-gordita-regular"])
                        }, _toDisplayString(_unref(workloads)[index]?.commandLine), 3),
                        (index === hoveredRow.value)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 8, _hoisted_5)
                  ])
                ]),
                _: 2
              }, 1032, ["status", "column-name"]))
            : _createCommentVNode("", true)
        ]),
        "content-FailedTasks": _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            value: _unref(workloads)[index]?.failedTasks ? _unref(workloads)[index]?.failedTasks?.toLocaleString() : 0,
            status: _unref(workloads)[index]?.buildResult as any,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].failedTasks as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["value", "status", "column-name", "class"])
        ]),
        [`content-Max.NeededHelperCores`]: _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            status: _unref(workloads)[index]?.buildResult as any,
            value: _unref(workloads)[index]?.maxNeededHelpersCores ? _unref(workloads)[index]?.maxNeededHelpersCores?.toLocaleString() : 0,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].maxNeededHelpersCores as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["status", "value", "column-name", "class"])
        ]),
        [`content-Max.HelperCores`]: _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            status: _unref(workloads)[index]?.buildResult as any,
            value: _unref(workloads)[index]?.maxBusyHelpersCores ? _unref(workloads)[index]?.maxBusyHelpersCores?.toLocaleString() : 0,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].maxBusyHelpersCores as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["status", "value", "column-name", "class"])
        ]),
        "content-UnmetHelperRequests": _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            value: (_unref(workloads)[index]?.readyOverActiveRatio || 0) + '%',
            status: _unref(workloads)[index]?.buildResult as any,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].readyOverActiveRatio as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["value", "status", "column-name", "class"])
        ]),
        "content-TotalTasks": _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            status: _unref(workloads)[index]?.buildResult as any,
            value: _unref(workloads)[index]?.totalTasks ? _unref(workloads)[index]?.totalTasks?.toLocaleString() : 0,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].totalTasks as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["status", "value", "column-name", "class"])
        ]),
        "content-RemoteTasks": _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            status: _unref(workloads)[index]?.buildResult as any,
            value: _unref(workloads)[index]?.remoteTasks ? _unref(workloads)[index]?.remoteTasks?.toLocaleString() : 0,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].remoteTasks as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["status", "value", "column-name", "class"])
        ]),
        "content-CloudTasks": _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            status: _unref(workloads)[index]?.buildResult as any,
            value: _unref(workloads)[index]?.cloudTasks ? _unref(workloads)[index]?.cloudTasks?.toLocaleString() : 0,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].cloudTasks as any,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["status", "value", "column-name", "class"])
        ]),
        "content-LocalTasks": _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            status: _unref(workloads)[index]?.buildResult as any,
            value: _unref(workloads)[index]?.localTasks ? _unref(workloads)[index]?.localTasks?.toLocaleString() : 0,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].localTasks as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["status", "value", "column-name", "class"])
        ]),
        "content-DistributableTasks": _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            value: _unref(workloads)[index]?.distributableTasks ? _unref(workloads)[index]?.distributableTasks?.toLocaleString() : 0,
            status: _unref(workloads)[index]?.buildResult as any,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].distributableTasks as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["value", "status", "column-name", "class"])
        ]),
        "content-BuildGroup": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.buildGroup)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                value: _unref(workloads)[index]?.buildGroup,
                status: _unref(workloads)[index]?.buildResult as any,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].buildGroup as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["value", "status", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-FailureReason": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.failReason)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                value: _unref(possibleFailReasons)[_unref(workloads)[index]?.failReason as keyof typeof possibleFailReasons] || '',
                status: _unref(workloads)[index]?.buildResult as any,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].failReason as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["value", "status", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-Hit": _withCtx(({ index }: { index: number }) => [
          (isValidValue(_unref(workloads)[index]?.cacheTaskHits))
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                status: _unref(workloads)[index]?.buildResult as any,
                value: _unref(workloads)[index]?.cacheTaskHits?.toLocaleString(),
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].cacheTaskHits as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["status", "value", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-Miss": _withCtx(({ index }: { index: number }) => [
          (isValidValue(_unref(workloads)[index]?.cacheTaskMiss))
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                status: _unref(workloads)[index]?.buildResult as any,
                value: _unref(workloads)[index]?.cacheTaskMiss?.toLocaleString(),
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].cacheTaskMiss as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["status", "value", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-UncacheableTasks": _withCtx(({ index }: { index: number }) => [
          (isValidValue(_unref(workloads)[index]?.uncacheableTasks))
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                status: _unref(workloads)[index]?.buildResult as any,
                value: _unref(workloads)[index]?.uncacheableTasks?.toLocaleString(),
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].uncacheableTasks as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["status", "value", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        [`content-Avg.HelperCores`]: _withCtx(({ index }: { index: number }) => [
          _createVNode(TableCell, {
            status: _unref(workloads)[index]?.buildResult as any,
            value: _unref(workloads)[index]?.avgBusyHelpersCores ? _unref(workloads)[index]?.avgBusyHelpersCores?.toLocaleString() : 0,
            "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(osService).osType.value || _unref(OsType).Windows].avgBusyHelpersCores as WorkloadsTableColumns,
            class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
          }, null, 8, ["status", "value", "column-name", "class"])
        ]),
        "content-InitiatorType": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.initiatorType)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                value: _unref(workloads)[index]?.initiatorType,
                status: _unref(workloads)[index]?.buildResult as any,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].initiatorType as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["value", "status", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-AgentDescription": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.agentDescription)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                value: _unref(workloads)[index]?.agentDescription,
                status: _unref(workloads)[index]?.buildResult as any,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].agentDescription as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["value", "status", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        "content-LoggedOnuser": _withCtx(({ index }: { index: number }) => [
          (_unref(workloads)[index]?.loggedOnUsers)
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                value: _unref(workloads)[index]?.loggedOnUsers,
                status: _unref(workloads)[index]?.buildResult as any,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          }),
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].loggedOnUsers as WorkloadsTableColumns
              }, null, 8, ["value", "status", "class", "column-name"]))
            : _createCommentVNode("", true)
        ]),
        "content-LogLevel": _withCtx(({ index }: { index: number }) => [
          (isValidValue(_unref(workloads)[index]?.loggingLevel))
            ? (_openBlock(), _createBlock(TableCell, {
                key: 0,
                value: _unref(LOG_LEVEL_WORKLOADS)[_unref(workloads)[index]?.loggingLevel as keyof typeof LOG_LEVEL_WORKLOADS],
                status: _unref(workloads)[index]?.buildResult as any,
                "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].loggingLevel as WorkloadsTableColumns,
                class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
              }, null, 8, ["value", "status", "column-name", "class"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        (_unref(isWindows))
          ? {
              name: "content-BuildTitle",
              fn: _withCtx(({ index }: { index: number }) => [
                (_unref(workloads)[index]?.title)
                  ? (_openBlock(), _createBlock(TableCell, {
                      key: 0,
                      value: _unref(workloads)[index]?.title,
                      status: _unref(workloads)[index]?.buildResult as any,
                      "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].title as WorkloadsTableColumns,
                      class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
                    }, null, 8, ["value", "status", "column-name", "class"]))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : {
              name: "content-BuildCaption",
              fn: _withCtx(({ index }: { index: number }) => [
                (_unref(workloads)[index]?.title)
                  ? (_openBlock(), _createBlock(TableCell, {
                      key: 0,
                      value: _unref(workloads)[index]?.title,
                      status: _unref(workloads)[index]?.buildResult as any,
                      "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Linux].title as WorkloadsTableColumns,
                      class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
                    }, null, 8, ["value", "status", "column-name", "class"]))
                  : _createCommentVNode("", true)
              ]),
              key: "1"
            },
        (_unref(isWindows))
          ? {
              name: "content-BuildType",
              fn: _withCtx(({ index }: { index: number }) => [
                (_unref(workloads)[index]?.buildType)
                  ? (_openBlock(), _createBlock(TableCell, {
                      key: 0,
                      value: _unref(workloads)[index]?.buildType,
                      status: _unref(workloads)[index]?.buildResult as any,
                      "column-name": _unref(workloadsConstants).COLUMNS_NAMES[_unref(OsType).Windows].buildType as WorkloadsTableColumns,
                      class: _normalizeClass({
            'cursor-pointer': _unref(workloads)[index]?.hasExtendedData,
          })
                    }, null, 8, ["value", "status", "column-name", "class"]))
                  : _createCommentVNode("", true)
              ]),
              key: "2"
            }
          : undefined,
        (_unref(osService)?.isWindows.value)
          ? {
              name: "floating-row",
              fn: _withCtx(({ index, hoveredRow: hovered, value }) => [
                (index === hovered && !value.hasExtendedData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('workloads.workloadsTable.noAvailableData')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              key: "3"
            }
          : undefined
      ]), 1032, ["columns", "items", "model-value"]),
      (!_unref(workloadsPageData)?.GQL?.loading.value && _unref(totalFilteredWorkloadsCount) === 0 && _unref(workloadsPageData)?.GQL?.networkStatus?.value === _unref(NetworkStatus).ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(EmptyBuildsSearch, {
              "button-text": _unref(t)('workloads.workloadsTable.noBuildsFound.buttonText'),
              "has-filters-applied": _unref(areFiltersApplied),
              class: "flex-grow w-full h-[calc(100%-40px)] bg-System/app_white",
              onClearFilters: clearFilters
            }, null, 8, ["button-text", "has-filters-applied"])
          ]))
        : (_unref(isManageColumnsFilterEmpty))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('workloads.workloadsTable.emptyColumnsFilter')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_unref(totalWorkloadsCount))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(totalWorkloadsCount)?.toLocaleString()), 1),
                (_unref(totalWorkloadsCount) === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, " build"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, " total builds"))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, "No builds for display")),
          (_unref(showWorkloadsTotalInFiltersCount))
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(totalFilteredWorkloadsCount)?.toLocaleString()), 1),
                  _hoisted_25
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_unref(IncrediPagination), {
              "model-value": _unref(workloadsPageData)?.filter?.get.value.paging.pageNumber || 0,
              "page-size": Math.ceil((_unref(totalFilteredWorkloadsCount) || 0) / (_unref(workloadsPageData)?.filter?.get.value.paging.pageSize || 0)),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = (pageNumber) => { _unref(workloadsPageData)?.filter &&  _unref(workloadsPageData)?.filter.setPageNumber(pageNumber) })
            }, null, 8, ["model-value", "page-size"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(_unref(IncrediSelect), {
              "model-value": _unref(workloadsPageData)?.filter?.get.value.paging.pageSize || 0,
              direction: "top-middle",
              size: "tiny",
              "min-width": 70,
              items: [50, 100, 150, 200],
              "override-style": {
              height: '28px',
              paddingLeft: '8px',
              paddingRight: '9px',
            },
              "onUpdate:modelValue": _cache[6] || (_cache[6] = pageSize => _unref(handlePageResize)(pageSize as number))
            }, null, 8, ["model-value"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})